import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import StateProvider from './components/utils/StateProvider';
import Theme from './components/utils/Theme';
import Routing from './components/utils/Routing';
import AclProvider from './components/utils/AclProvider';

function App() {
  return (
    <Theme>
      <StateProvider>
        <AclProvider>
          <BrowserRouter>
            <Routing />
          </BrowserRouter>
        </AclProvider>
      </StateProvider>
    </Theme>
  );
}

export default App;
